module.exports = __webpack_public_path__ + "img/14.47531bc6.png";